import { INSERT_HORIZONTAL_RULE_COMMAND } from '@lexical/react/LexicalHorizontalRuleNode';
import { StaticModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { getTranslation } from '@nexelem/utils';
import { LexicalEditor } from 'lexical';
import { InjectedProps } from 'material-ui-popup-state';
import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InsertNewTableDialog } from '../../plugins/TablePlugin/InsertNewTableDialog';
import { ActionButton } from '../ActionButton';
import { ButtonWithMenu } from '../ButtonWithMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faHorizontalRule, faTable } from '@fortawesome/pro-light-svg-icons';

type InsertDropDownProps = {
  readonly disabled?: boolean;
  readonly editor: LexicalEditor;
};

export const InsertDropDown = ({ disabled, editor }: InsertDropDownProps) => {
  const { t: translate } = useTranslation();
  const t = useMemo(() => getTranslation(translate, 'components.richTextEditor.insertDropDown'), [translate]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClickHorizontalRule = useCallback(() => {
    editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined);
  }, [editor]);

  const onToggleOpenModal = useCallback(() => {
    setIsModalOpen((prevState) => !prevState);
  }, []);

  const onClickTable = (popupState: InjectedProps) => () => {
    onToggleOpenModal();
    popupState.close();
  };

  return (
    <div className="flex items-center justify-between">
      <ButtonWithMenu
        disabled={disabled}
        content={(popupState) => (
          <>
            <ActionButton
              Icon={<FontAwesomeIcon icon={faTable} />}
              label={t('table')}
              onClick={onClickTable(popupState)}
            />
            <ActionButton
              Icon={<FontAwesomeIcon icon={faHorizontalRule} />}
              label={t('horizontalRule')}
              onClick={onClickHorizontalRule}
            />
          </>
        )}
        openingElement={
          <Button EndIcon={<FontAwesomeIcon icon={faAngleDown} />} variant="text">
            {t('insert')}
          </Button>
        }
      />
      <StaticModal isOpen={isModalOpen} onClose={onToggleOpenModal}>
        <InsertNewTableDialog activeEditor={editor} onClose={onToggleOpenModal} />
      </StaticModal>
    </div>
  );
};
InsertDropDown.displayName = 'InsertDropDown';
